(function() {
    'use strict';

    angular
        .module('elogbooks.admin.sites')
        .controller('SitePartnershipsModifyController', SitePartnershipsModifyController);

    SitePartnershipsModifyController.$inject = [
        'siteResponse',
        'apiClient',
        '$state',
        '$rootScope',
        'messenger',
        'validationService',
        'confirmationModal',
        'crudService'
    ];

    function SitePartnershipsModifyController(
        siteResponse,
        apiClient,
        $state,
        $rootScope,
        messenger,
        validationService,
        confirmationModal,
        crudService
    ) {
        var vm = this;

        vm.validationService = validationService;
        vm.action = null;
        vm.loading = false;
        vm.deleteUnusedPartnerships = deleteUnusedPartnerships;
        vm.continueToAddServiceProviders = continueToAddServiceProviders;
        vm.addAllServiceProviders = addAllServiceProviders;

        function continueToAddServiceProviders() {
            vm.loading = true;

            return validationService.exitFormWithNoDirtyCheck('^.add');
        }

        function deleteUnusedPartnerships() {
            return confirmationModal.open({
                bodyMessage: 'WILL_DELETE_ALL_PARTNERSHIPS_FROM_SITE',
                primaryText: 'CONFIRM',
                secondaryText: 'CANCEL'
            }).result.then(function(response) {
                if (!response.result) {
                    return;
                }

                vm.loading = true;

                return apiClient.delete(siteResponse.getLink('delete-unused-partnerships')).then(function(response) {

                    if (response) {
                        return $state.go('dashboard.admin.sites.list.details.partnerships', {}, {reload: true}).then(function() {
                            messenger.success('PARTNERSHIPS_UPDATED');
                        });
                    }

                    messenger.error('REQUEST_ERROR');
                    vm.loading = false;
                });
            });
        }

        function addAllServiceProviders() {
            vm.loading = true;
            $rootScope.skipDirtyCheck = true;

            return crudService.create(
                siteResponse.getLink('add-all-active-service-providers'),
                {},
                null,
                null,
                null,
                true
            ).then(function(response) {
                if (response) {
                    return $state.go('dashboard.admin.sites.list.details.partnerships', {}, {reload: true}).then(function() {
                        $rootScope.skipDirtyCheck = false;
                        messenger.success('PARTNERSHIPS_UPDATED');
                    }, function() {
                        $rootScope.skipDirtyCheck = false;
                        vm.loading = false;
                        messenger.error('REQUEST_ERROR');
                    });
                }

                $rootScope.skipDirtyCheck = false;
                vm.loading = false;
            });
        }
    }
})();
